import { createEffect } from 'effector';

import { apiFetch } from '@m/utils/http';

export const fetchForceCloseReasons = createEffect({
  handler: () => apiFetch('/specialist/visits/force-close-reasons'),
});

export const forceCloseVisit = createEffect({
  handler: async ({
    visitId,
    forceCloseReasonId,
  }: {
    forceCloseReasonId: number;
    visitId: number;
  }) =>
    apiFetch(`/specialist/visit/${visitId}/force-close`, {
      method: 'POST',
      body: {
        forceCloseReason: { id: forceCloseReasonId },
      },
    }),
});
